export const aspectMode = {
  SCALE: 0, // 入力のアスペクト比に合わせ、出力の幅、高さにおさめる
  FORCE_SCALE: 1, // 入力のアスペクト比を無視し、出力の幅、高さに合わせる
  CROP: 2, // 出力を満たすように入力を拡大・縮小し、はみだした領域を切り取る
  PAD: 3, // 入力のアスペクト比に合わせ、埋まらない部分を背景色で埋める
} as const
export type AspectMode = (typeof aspectMode)[keyof typeof aspectMode]

export const upEnlargeOrigin = {
  NONE: 0, // 許可しない
  ALLOW: 1, // 拡大可能
} as const
type UpEnlargeOrigin = (typeof upEnlargeOrigin)[keyof typeof upEnlargeOrigin]

export const format = {
  AUTO: 'auto', // 入力画像と同じフォーマット
  PNG: 'png',
  GIF: 'gif',
  WEBP: 'webp',
  WEBP_AUTO: 'webp:auto', // WebPまたは入力画像と同じフォーマット
  WEBP_JPG: 'webp:jpg', // WebP（クライアントが対応していない場合JPEG）
  WEBP_PNG: 'webp:png', // WebP（クライアントが対応していない場合PNG）
  WEBP_GIF: 'webp:gif', // WebP（クライアントが対応していない場合GIF）
} as const
type Format = (typeof format)[keyof typeof format]

export type ImageFluxOption = {
  aspectMode?: AspectMode // 出力画像のアスペクトモード
  upEnlargeOrigin?: UpEnlargeOrigin // 出力画像が入力画像より拡大するか
  format?: Format // 出力する画像フォーマットを指定する
  quality?: number // 出力画像の圧縮品質
  height?: number // 出力画像の高さ
  width?: number // 出力画像の幅
}

export type GetImageFluxUrlArgs = {
  path: string // 画像のs3パス
  option?: ImageFluxOption // 画像変換設定
  excludedExtensions?: string[] // 除外する拡張子の配列 (デフォルトは ["svg"])
  noCompression?: boolean // 圧縮せずにそのまま取得
}

export const useImageFlux = () => {
  const config = useRuntimeConfig()
  const getImageFluxUrl = ({
    path = '',
    option = {},
    excludedExtensions = ['svg'],
    noCompression = false,
  }: GetImageFluxUrlArgs): string => {
    if (
      !path ||
      typeof path !== 'string' ||
      !path.startsWith('/') ||
      !config.public.imageFluxBaseUrl
    ) {
      return path
    }

    if (excludedExtensions) {
      const extension = path.split('.').pop()
      if (extension && excludedExtensions.includes(extension)) {
        return path
      }
    }

    if (noCompression) {
      return `${config.public.imageFluxBaseUrl}${path}`
    }

    const queryOptions = {
      a: option.aspectMode !== undefined ? option.aspectMode : aspectMode.CROP,
      u:
        option.upEnlargeOrigin !== undefined
          ? option.upEnlargeOrigin
          : upEnlargeOrigin.ALLOW,
      f: option.format || format.WEBP_AUTO,
      q: option.quality || 85,
      h: option.height,
      w: option.width,
      through: 'gif',
      ir: 'auto',
    }

    const param = Object.entries(queryOptions)
      .filter((kv) => kv[1] !== undefined)
      .map(([key, value]) => `${key}=${value}`)
      .join(',')

    return `${config.public.imageFluxBaseUrl}/${param}${path}`
  }
  return {
    getImageFluxUrl,
  }
}
